import backend, {JOB_API} from 'utils/backend/server/api_library';

import queryString from 'query-string';

const getJob = (jobRn) => {
  const url = `${JOB_API}/career/job/${jobRn}/public`;
  return backend.get(url);
};

const getJobs = (filters, sort, lastEvaluatedKey) => {
  const queryParam = {
    lastEvaluatedKey: lastEvaluatedKey,
  };
  if (filters) {
    queryParam.filters = JSON.stringify(filters);
  }
  if (sort) {
    queryParam.sort = JSON.stringify(sort);
  }
  const query = queryString.stringify(queryParam, {skipNull: true, skipEmptyString: true});
  const url = `${JOB_API}/career/job/public?${query}`;
  return backend.get(url);
};

export default {
  getJobs,
  getJob,
};
